module.exports = __webpack_public_path__ + "img/4_71.0ac75308.png";